import { useEffect, useState, type FC } from "react";
import { Tag } from "../../../models/inventory/product";
import { Button, Form, Input, Loader, Modal, Uploader } from "rsuite";
import { asyncLocalStorage } from "../../../utils/storage";
import { BsCamera } from "react-icons/bs";
import { errorToast, successToast } from "../../../utils/helper-ui";
import { GrAttachment } from "react-icons/gr";

interface TagFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: Tag) => void;
  tag?: Tag;
}

const TagForm: FC<TagFormProps> = ({ open, onClose, onSubmit, tag }) => {
  const [data, setData] = useState<Tag>({
    id: "",
    name: "",
  });
  const [uploading, setUploading] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    asyncLocalStorage.getItem("token").then((token) => {
      setToken(token);
    });
  }, []);

  useEffect(() => {
    if (tag) {
      setData(tag);
    }
  }, [tag]);

  const clearForm = () => {
    setData({
      id: "",
      name: "",
      color: "",
      icon_url: "",
    });
  };

  return (
    <Modal
      size={"lg"}
      open={open}
      onClose={() => {
        clearForm();
        onClose();
      }}
    >
      <Modal.Header>Tag Form</Modal.Header>
      <Modal.Body>
        <Form className="w-full" layout="horizontal" fluid>
          <div className="form-group">
            <label>Name</label>
            <Input
              name="name"
              placeholder="e.g. Nike BRAND Corporation"
              value={data.name}
              onChange={(value) => setData({ ...data, name: value })}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <Input
              as={"textarea"}
              rows={4}
              name="description"
              placeholder="e.g. Nike is a world-renowned sportswear and footwear company."
              onChange={(value) => setData({ ...data, description: value })}
            />
          </div>
          <div className="form-group">
            <label>Icon</label>

            <Uploader
              fileListVisible={false}
              listType="picture"
              accept="image/*"
              action={process.env.REACT_APP_API_URL + "/v1/file/upload"}
              onUpload={(file) => {
                setUploading(true);
              }}
              headers={{
                Authorization: `Bearer ${token}`,
              }}
              onSuccess={(response, file) => {
                setUploading(false);
                successToast("File uploaded successfully");
                setData({ ...data, icon_url: response.file.url });
              }}
              onError={() => {
                setUploading(false);
                errorToast("Upload failed");
              }}
            >
              <button
                style={{
                  width: 150,
                  height: 150,
                  backgroundColor: data?.color,
                }}
              >
                {uploading && <Loader backdrop center />}
                {data.icon_url ? (
                  <img src={data.icon_url} width="40" height="40" />
                ) : (
                  <GrAttachment
                    className="text-white"
                    style={{ fontSize: 40 }}
                  />
                )}
              </button>
            </Uploader>
          </div>
          <div className="form-group">
            <label>Color</label>
            <div className="input">
              <Input
                name="color"
                placeholder="Name"
                value={data.color}
                type="color"
                className="color-picker"
                onChange={(value, event) => setData({ ...data, color: value })}
              />
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button
            appearance="primary"
            onClick={() => {
              onSubmit(data!);
              setData({
                id: "",
                name: "",
                color: "",
                icon_url: "",
              });
            }}
          >
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default TagForm;
